package org.lennycodes.hldi.styles
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.autoLength
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.px
import org.lennycodes.hldi.constants.HLDITheme

val HeroSectionStyle = CssStyle {
    base {
        Modifier
            .color(HLDITheme.Colors.white)
            .textAlign(TextAlign.Center)
            .padding(50.px, 20.px)
            .position(Position.Relative) // anchors the wave SVG below
            .styleModifier {
                property(
                    "background",
                    "linear-gradient(135deg, ${HLDITheme.Colors.primary} 0%, ${HLDITheme.Colors.secondary} 100%)"
                )
            }
    }
}

val HeroTitleStyle = CssStyle {
    base {
        Modifier
            .fontSize(48.px)
            .fontFamily("Playfair Display", "serif")
            .margin(bottom = 16.px)
    }
}

val HeroTextStyle = CssStyle {
    base {
        Modifier
            .fontSize(18.px)
            .opacity(0.95)
            .margin(0.px, autoLength)
    }
}